import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "../motion/Reveal";

const CLIPS = {
  "security-surveillance": {
    src: "/videos/solutions/security-surveillance.mp4",
    poster: "/videos/solutions/security-surveillance-poster.jpg",
    label: "Watch: Security & Surveillance in 20 seconds",
  },
  automation: {
    src: "/videos/solutions/automation.mp4",
    poster: "/videos/solutions/automation-poster.jpg",
    label: "Watch: Smart Automation in 20 seconds",
  },
};

export const SolutionClip = ({ slug }) => {
  const clip = CLIPS[slug];
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  if (!clip) return null;

  const start = () => {
    setPlaying(true);
    requestAnimationFrame(() => videoRef.current?.play());
  };

  return (
    <section className="bg-nx-navy2 border-y border-white/10 py-12 sm:py-16" data-testid={`solution-clip-${slug}`}>
      <div className="nx-wrap">
        <Reveal>
          <div className="relative aspect-video overflow-hidden border border-white/10 bg-black group max-w-4xl mx-auto">
            <video
              ref={videoRef}
              className="w-full h-full object-cover"
              poster={clip.poster}
              controls={playing}
              preload="metadata"
              playsInline
              onEnded={() => setPlaying(false)}
              data-testid="solution-clip-player"
            >
              <source src={clip.src} type="video/mp4" />
            </video>
            {!playing && (
              <button
                onClick={start}
                className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-nx-navy/30 hover:bg-nx-navy/10 transition-colors duration-300"
                aria-label="Play solution video"
                data-testid="solution-clip-play"
              >
                <span className="flex items-center justify-center w-16 h-16 rounded-full bg-nx-gold text-nx-navy shadow-[0_0_50px_rgba(189,137,49,0.45)] transition-transform duration-300 group-hover:scale-110">
                  <Play size={26} className="ml-1" fill="currentColor" />
                </span>
                <span className="text-[10px] tracking-[0.26em] uppercase text-nx-goldlight">{clip.label}</span>
              </button>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
